(function () {
  'use strict';
 
  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
 
  class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.newsletterPopup = null;
      this.closeButton = null;
    }

    connectedCallback() {
      this.initModal();
    }

    initModal() {
      this.newsletterPopup = this.querySelector('#newsletter_model');
      this.closeButton = this.querySelector('#newsletter_model .close-btn');

      if (!this.newsletterPopup || getCookie('newsletter_shown')) {
        return;
      }

      var isThemeEditor = window.Shopify && window.Shopify.designMode;
      var delay = parseInt(this.newsletterPopup.dataset.delay || '0', 10);
      var expiryDays = parseInt(this.newsletterPopup.dataset.expiry || '30', 10);

      if (!isThemeEditor && getCookie('newsletter_shown')) {
        return;
      }

      setTimeout(() => {
        this.showModal();

        if (!isThemeEditor) {
          setCookie('newsletter_shown', 'true', expiryDays);
        }
      }, delay);

      this.initEventListeners();
    }

    initEventListeners() {
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.hideModal());
      }

      document.addEventListener('click', (event) => {
        if (!event.target.closest('.newsletter-popup, .trigger')) {
          this.hideModal();
        }
      });
    }

    showModal() {
      this.newsletterPopup.classList.remove('d-none');
      this.newsletterPopup.classList.add('d-flex');
    }

    hideModal() {
      if (this.newsletterPopup) {
        this.newsletterPopup.classList.remove('d-flex');
        this.newsletterPopup.classList.add('d-none');
        this.newsletterPopup.style.setProperty('display', 'none', 'important');
      }

      var popupModal = this.querySelector('.newsletter-popup');

      if (popupModal) {
        popupModal.style.setProperty('display', 'none', 'important');
      }
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }
 
  class AgeVerification extends HTMLElement {
    connectedCallback() { 
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      if (this.modal) {
        this.modal.dispose();
        this.modal = null;
      } 
      document.querySelectorAll('.modal-backdrop').forEach(function (el) {
        el.remove();
      });
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      delete this.dataset.ageInit;
    }

    init() {
      if (this.dataset.ageInit === 'true') return;

      this.modalEl = this.querySelector('#confirmModal');
      this.acceptBtn = this.querySelector('#confirmButton');
      this.declineBtn = this.querySelector('#cancelButton');

      if (!this.modalEl || typeof window.bootstrap === 'undefined') {
        return;
      }

      this.dataset.ageInit = 'true';

      this.isThemeEditor = window.Shopify && window.Shopify.designMode;
      this.declineUrl = this.dataset.declineUrl || 'https://www.google.com';
      this.expiryDays = parseInt(this.dataset.expiry || '30', 10);
 
      var existing = window.bootstrap.Modal.getInstance(this.modalEl);
      if (existing) existing.dispose();
      document.querySelectorAll('.modal-backdrop').forEach(function (el) {
        el.remove();
      });

      this.modal = new window.bootstrap.Modal(this.modalEl);

      this.acceptBtn && this.acceptBtn.addEventListener('click', () => this.accept());
      this.declineBtn && this.declineBtn.addEventListener('click', () => this.decline());

      if (this.isThemeEditor || !getCookie('age_verified')) {
        this.modal.show();
      }
    }

    accept() {
      if (!this.isThemeEditor) {
        setCookie('age_verified', 'true', this.expiryDays);
      }
      this.modal.hide();
    }

    decline() {
      if (this.isThemeEditor) {
        this.modal.hide();
        return;
      }
      window.location.href = this.declineUrl;
    }
  }

  if (!customElements.get('age-verification')) {
    customElements.define('age-verification', AgeVerification);
  }
 
  class SuggestedProductsPopup extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.showTimer = null;
      this.hideTimer = null;
      this.paused = false;
      this.hoverPaused = false;
    }

    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('.recent-product-data'));
      if (!this.items.length) return;

      this.visibleDuration = parseInt(this.dataset.visibleDuration || '5000', 10);
      this.hiddenInterval = parseInt(this.dataset.hiddenInterval || '3000', 10);
      this.isThemeEditor = window.Shopify && window.Shopify.designMode;

      if (!this.isThemeEditor && getCookie('suggested_products_closed')) {
        return;
      }

      this.addEventListener('click', (event) => {
        var closeBtn = event.target.closest('.recent-product-close');
        if (closeBtn) {
          event.preventDefault();
          this.closeCurrent();
        }
      });

      this.items.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (this.paused) return;
          this.hoverPaused = true;
          clearTimeout(this.hideTimer);
          this.hideTimer = null;
        });
        item.addEventListener('mouseleave', () => {
          if (!this.hoverPaused) return;
          this.hoverPaused = false;
          if (this.paused) return;
          this.startHideTimer(item);
        });
      });

      if (this.isThemeEditor) {
        this.onBlockSelect = (event) => {
          var item = event.target && event.target.closest ? this.items.find((el) => el.contains(event.target) || el === event.target) : null;
          if (!event.target || !this.contains(event.target)) return;
          this.pauseCycle();
          this.items.forEach((el) => el.classList.remove('active'));
          if (item) item.classList.add('active');
        };
        this.onBlockDeselect = (event) => {
          if (!event.target || !this.contains(event.target)) return;
          this.resumeCycle();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      this.showCurrent();
    }

    disconnectedCallback() {
      this.clearTimers();
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    clearTimers() {
      clearTimeout(this.showTimer);
      clearTimeout(this.hideTimer);
      this.showTimer = null;
      this.hideTimer = null;
    }

    pauseCycle() {
      this.paused = true;
      this.clearTimers();
    }

    resumeCycle() {
      this.paused = false;
      this.items.forEach((el) => el.classList.remove('active'));
      this.scheduleNext();
    }

    showCurrent() {
      if (this.paused) return;
      var item = this.items[this.currentIndex];
      item.classList.add('active');
      if (!this.hoverPaused) {
        this.startHideTimer(item);
      }
    }

    startHideTimer(item) {
      this.hideTimer = setTimeout(() => {
        item.classList.remove('active');
        this.scheduleNext();
      }, this.visibleDuration);
    }

    closeCurrent() {
      this.paused = true;
      this.clearTimers();
      this.items.forEach((el) => el.classList.remove('active'));

      if (!this.isThemeEditor) {
        setCookie('suggested_products_closed', 'true', 1);
      }
    }

    scheduleNext() {
      if (this.paused) return;
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.showTimer = setTimeout(() => this.showCurrent(), this.hiddenInterval);
    }
  }

  if (!customElements.get('suggested-products-popup')) {
    customElements.define('suggested-products-popup', SuggestedProductsPopup);
  }

  function isOfferSection(node) {
    return node && node.classList && node.classList.contains('offer_popup');
  }

  function initOfferPopup(root) {
    var scope = root || document;
    var preview = scope.querySelector('#offer_popup_preview');

    if (!preview) return;
 
    if (preview.dataset.offerInit === 'true') return;
    preview.dataset.offerInit = 'true';

    var isEditor = window.Shopify && window.Shopify.designMode;
 
    if (!isEditor && document.cookie.indexOf('dT_offer-cookie=closed') !== -1) {
      preview.classList.add('d-none');
    } else {
      preview.classList.remove('d-none');
    }

    var previewClose = preview.querySelector('.offer-popup-preview__close');
    if (previewClose) {
      previewClose.addEventListener('click', function (e) {
        e.stopPropagation();
        preview.classList.add('d-none');
        if (!isEditor) {
          document.cookie = 'dT_offer-cookie=closed;path=/;max-age=86400';
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initOfferPopup(); });
  } else {
    initOfferPopup();
  }
  window.addEventListener('load', function () { initOfferPopup(); });
  document.addEventListener('shopify:section:load', function (e) {
    if (isOfferSection(e.target)) initOfferPopup(e.target);
  });
})();